import { createHttpLink, HttpLink } from "apollo-link-http";

import { getConfig } from "../../../config/app";
const getURI = () => getConfig("graphql.dataSourcerEndpoint");

export const getLink = (httpLinkConfig: HttpLink.Options = {}) =>
  createHttpLink({
    uri: getURI(),
    ...httpLinkConfig
  });
